export const HOST = process.env.REACT_APP_HOST_API;
export const VERSION = 'api/v1/';

const APP_URL = {
    BUSCARCOTIZACION: `${HOST}${VERSION}web/form/buscarCotizacion`,
    GUARDARAPROBACIONCOTIZACION: `${HOST}${VERSION}web/form/guardarAprobacionCotizacion`
}

export default APP_URL
